__turbopack_context__.v({
  "active": "prematch-all-tournament-module-sass-module__ncclWa__active",
  "tournamentItem": "prematch-all-tournament-module-sass-module__ncclWa__tournamentItem",
});
